import { useTranslation } from 'react-i18next'

import { EMPTY_STRING } from '../../../constants/common'
import { useScreen } from '../../../hooks'
import Button from '../../Button'

import DeleteIcon from '../../../icons/delete.svg'

function FilterBarClearFiltersButton({ isSkeleton, qaName, onClick }) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <Button.Text
      isGreySecondary
      isHovered
      beforeIconProps={{ Icon: DeleteIcon }}
      isSkeleton={isSkeleton}
      qaName={qaName}
      text={isMobileScreenSize ? EMPTY_STRING : t('Table.ClearFilterBtnKey')}
      onClick={onClick}
    />
  )
}

export default FilterBarClearFiltersButton
